"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveAttributeFilterHandler = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var effects_1 = require("redux-saga/effects");
var general_1 = require("../../../events/general");
var filters_1 = require("../../../events/filters");
var filterContext_1 = require("../../../store/filterContext");
var filterContextSelectors_1 = require("../../../store/filterContext/filterContextSelectors");
var common_1 = require("../common");
var eventDispatcher_1 = require("../../../store/_infra/eventDispatcher");
function moveAttributeFilterHandler(ctx, cmd) {
    var _a, filterLocalId, index, affectedFilter, allFilters, maximalTargetIndex, originalIndex, finalIndex;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = cmd.payload, filterLocalId = _a.filterLocalId, index = _a.index;
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterByLocalId(filterLocalId))];
            case 1:
                affectedFilter = _b.sent();
                if (!affectedFilter) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Filter with filterLocalId " + filterLocalId + " not found.");
                }
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextFilters)];
            case 2:
                allFilters = _b.sent();
                maximalTargetIndex = allFilters.length - 1;
                if (index > maximalTargetIndex || index < -1) {
                    throw general_1.invalidArgumentsProvided(ctx, cmd, "Invalid index (" + index + ") provided, it must be between -1 and " + maximalTargetIndex);
                }
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterIndexByLocalId(filterLocalId))];
            case 3:
                originalIndex = _b.sent();
                return [4 /*yield*/, effects_1.put(filterContext_1.filterContextActions.moveAttributeFilter({
                        filterLocalId: filterLocalId,
                        index: index,
                    }))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects_1.select(filterContextSelectors_1.selectFilterContextAttributeFilterIndexByLocalId(filterLocalId))];
            case 5:
                finalIndex = _b.sent();
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(filters_1.attributeFilterMoved(ctx, affectedFilter, originalIndex, finalIndex, cmd.correlationId))];
            case 6:
                _b.sent();
                return [4 /*yield*/, effects_1.call(common_1.dispatchFilterContextChanged, ctx, cmd)];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.moveAttributeFilterHandler = moveAttributeFilterHandler;
//# sourceMappingURL=moveAttributeFilterHandler.js.map